/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'extension.charts.aggregateData': 'データを集計',
  'extension.charts.aggregateDataDescription': '複数の列が同じ値を持つ場合は、値を 1 つのデータ ポイントにまとめます。',
  'extension.charts.category': 'カテゴリ',
  'extension.charts.customizeTab': 'カスタマイズ',
  'extension.charts.dataMissing.details': 'このグラフのソースとなる表がページで見つかりません。',
  'extension.charts.dataMissing.title': '表示するデータがありません',
  'extension.charts.dataTab': 'データ',
  'extension.charts.defaultColumnName': 'コラム {0}',
  'extension.charts.defaultTitle': '無題のグラフ',
  'extension.charts.defaultYLabel': '無題の軸',
  'extension.charts.extensionTitle': 'グラフ',
  'extension.charts.height': '領域の高さを決める',
  'extension.charts.height.large': '長くする',
  'extension.charts.height.medium': '既定',
  'extension.charts.height.small': '短くする',
  'extension.charts.horizontal.orientation.label': '横',
  'extension.charts.insert.tooltip': 'グラフを挿入',
  'extension.charts.legend': '凡例',
  'extension.charts.legend.auto': '自動',
  'extension.charts.legend.bottom': '下',
  'extension.charts.legend.left': '左',
  'extension.charts.legend.position': '凡例の位置',
  'extension.charts.legend.right': '右',
  'extension.charts.legend.show': '凡例を表示',
  'extension.charts.legend.top': '上',
  'extension.charts.options.label': 'グラフのオプション',
  'extension.charts.options.tooltip': 'グラフのオプションを変更',
  'extension.charts.orientation.label': '向き',
  'extension.charts.seriesNames': 'データ系列',
  'extension.charts.showPoints': 'データ ポイントを表示',
  'extension.charts.smoothLines': 'なめらかな線',
  'extension.charts.style': 'スタイル',
  'extension.charts.title': 'タイトル',
  'extension.charts.type.bar': '棒',
  'extension.charts.type.fieldDescription': 'グラフの種類',
  'extension.charts.type.line': '折れ線',
  'extension.charts.type.pie': '円',
  'extension.charts.userTitle': 'タイトル',
  'extension.charts.vertical.orientation.label': '縦',
  'extension.charts.xAxis': 'X 軸',
  'extension.charts.xLabel': 'X 軸のラベル',
  'extension.charts.yLabel': 'Y 軸のラベル',
};
